import React, { useState, createContext, useEffect } from 'react';

export const AppContext = createContext();

const AllContext = ({ children }) => {
   const [isVideoOpen, setIsVideoOpen] = useState(false);
   const [stickyMenu, setStickyMenu] = useState(false);
   const [hideHeader, setHideHeader] = useState(false);
   // sticky + hide-on-scroll-down / show-on-scroll-up
   useEffect(() => {
      let lastScrollY = window.scrollY;
      const stickyMenuBar = () => {
         const currentScrollY = window.scrollY;
         setStickyMenu(currentScrollY > 80);

         if (currentScrollY > 80 && currentScrollY > lastScrollY + 5) {
            setHideHeader(true);
         } else if (currentScrollY < lastScrollY - 5 || currentScrollY <= 80) {
            setHideHeader(false);
         }
         lastScrollY = currentScrollY;
      }
      window.addEventListener('scroll', stickyMenuBar);
      return () => window.removeEventListener('scroll', stickyMenuBar);
   }, [])
   const values = {
      isVideoOpen,
      setIsVideoOpen,
      stickyMenu,
      hideHeader,
   }
   return (
      <>
         <AppContext.Provider value={values}>
            {children}
         </AppContext.Provider>
      </>
   );
};

export default AllContext;